/* eslint-disable react/button-has-type */
import React from "react";
import ReviewAgentIcon from '../../../assets/logos/IntakeReviewAgent.svg';
import BenefitAgentIcon from '../../../assets/logos/BenefitAgent.svg';
import ApplicationAssistant from '../../../assets/logos/ApplicationStatusAgent.svg';
import EligibilityAgentIcon from '../../../assets/logos/EligibilityReviewAgent.svg';
import DocumentAgentIcon from '../../../assets/logos/DocumentQualityAgent.svg';
import '../../../styles/AgentHeader.css';
import { AGENT_TYPES } from "../../../constants/agentTypes";

const AgentHeader = ({ onClose, agentName, isReviewAgentScreen }) => {
  const AGENT_ICON_MAP = {
    [AGENT_TYPES.APPLICATION_STATUS]: ApplicationAssistant,
    [AGENT_TYPES.ELIGIBILITY_REVIEW]: EligibilityAgentIcon,
    [AGENT_TYPES.DOCUMENT]: DocumentAgentIcon,
  };


  const getAgentIcon = () => {
    const mappedIcon = AGENT_ICON_MAP[agentName];

    if (mappedIcon) return mappedIcon;

    if (isReviewAgentScreen) return ReviewAgentIcon;

    return BenefitAgentIcon;
  };

  return (
    <div className="agent-header">
      <div className="avatar">
        <img src={getAgentIcon()} alt="agent" />
      </div>

      <div className="title-wrapper">
        <span className="title">{agentName}</span>
      </div>

      <button className="close-btn" onClick={onClose}>
        ✕
      </button>
    </div>
  )
};

export default AgentHeader;
